import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

import { getOrder } from '../../../apis/queries';
import PrintDetailsButton from '../../../components/Print';
import Header from '../../../widgets/Header';
import DetailNotFound from '../../DetailNotFound';
import OrderSummary from './OrderSummary';

const CreateReturnsButton = ({ onClick }: { onClick: () => void }) => {
  return <Button onClick={onClick}> Create Return </Button>;
};

const OrderDetails = () => {
  const { id } = useParams();

  if (!id) {
    return <DetailNotFound />;
  }

  return <OrderDetailsContent id={id} />;
};

const OrderDetailsContent = ({ id }: { id: string }) => {
  const navigate = useNavigate();
  const orderSummaryRef = useRef<HTMLDivElement>(null);
  const ORDER_ID_QUERY_KEY = ['orders', { id }];
  const { data, isLoading } = useQuery({
    queryKey: ORDER_ID_QUERY_KEY,
    queryFn: () => getOrder(id)
  });

  const order = data?.data;

  if (isLoading)
    return (
      <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" />
      </Container>
    );

  if (!order) {
    return <DetailNotFound />;
  }

  const customer = order.customer;

  return (
    <div className="main-content pb-4">
      <Header
        title={`${customer?.name} - ${order.orderNumber}`}
        isDetailPage
        headerButton={
          order.hasReturnOrder || order.status !== 'open' ? (
            <></>
          ) : (
            <CreateReturnsButton
              onClick={() => {
                navigate(`/orders/${id}/create-returns`);
              }}
            />
          )
        }
      />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            {order && (
              <div ref={orderSummaryRef} id="printable-order-summary">
                <OrderSummary customer={customer} order={order} showNotes={true} title="Order Details" />
              </div>
            )}
          </Col>
        </Row>
        <Row className="justify-content-end row">
          <Col xs="auto" className="d-flex gap-2">
            <PrintDetailsButton
              orderNumber={order?.orderNumber}
              customer={customer}
              orderSummaryRef={orderSummaryRef}
            />
            <PrintDetailsButton
              orderNumber={order?.orderNumber}
              customer={customer}
              orderSummaryRef={orderSummaryRef}
              paperSize="pos"
              label="POS Print"
            />
            {/* <PrintDetailsButton
              orderNumber={order?.orderNumber}
              customer={customer}
              orderSummaryRef={orderSummaryRef}
              paperSize="pos"
              preview
              label="POS Preview"
            /> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OrderDetails;
